import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

// Same shape as growth's contract, so detections from it assign structurally.
interface MedicationDetection {
  matched_text: string;
  normalized_name: string;
  span_start: number;
  span_end: number;
  name_type?: 'generic' | 'brand' | 'local' | 'unknown' | null;
}

/** Per-session detections — no cross-session PHI bleed. */
export const medicationDetectionsAtomFamily = atomFamily((sessionId: string) => {
  void sessionId;
  return atom<MedicationDetection[]>([]);
});
